module.exports = __webpack_public_path__ + "img/photo-avin.8680f0ba.jpg";